import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    PieChart,
    Pie,
    Cell,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { getStatics } from "../Redux/Actions/auth";

const COLORS = ["#198754", "#dc3545"];

export default function FeedbackSummary() {
    const analytics = useSelector((e) => e.userAuth.staticsData);
    const dispatch = useDispatch()

    const Inialize = () => {
        try {
            dispatch(getStatics()).then((res) => {
            });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        Inialize();
    }, []);

    const pieData = [
        { name: "Positive", value: analytics?.totalPositiveFeedback },
        { name: "Negative", value: analytics?.totalNegativeFeedback },
    ];

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-body">
                    <h4 className="card-title mb-4">Feedback Summary</h4>
                    <div className="row">
                        {/* Left side: Donut chart */}
                        <div className="col-md-6 d-flex flex-column align-items-center">
                            <PieChart width={200} height={200}>
                                <Pie
                                    data={pieData}
                                    innerRadius={70}
                                    outerRadius={90}
                                    paddingAngle={3}
                                    dataKey="value"
                                >
                                    {pieData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                    ))}
                                </Pie>
                                <text
                                    x={100}
                                    y={100}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    className="fw-bold fs-4"
                                >
                                    {analytics?.totalPositiveFeedback + analytics?.totalNegativeFeedback}%
                                </text>
                            </PieChart>
                            <div className="mt-3 text-center">
                                <div className="text-success fw-semibold">
                                    👍 Positive <span className="text-dark">{analytics?.totalPositiveFeedback}%</span>
                                </div>
                                <div className="text-danger fw-semibold">
                                    👎 Negative <span className="text-dark">{analytics?.totalNegativeFeedback}%</span>
                                </div>
                            </div>
                        </div>

                        {/* Right side: Line chart */}
                        <div className="col-md-6">
                            <div className="d-flex justify-content-between mb-2">
                                <strong>Trends Over Time</strong>
                                {/* <div className="btn-group btn-group-sm">
                                    <button className="btn btn-outline-dark active">7d</button>
                                    <button className="btn btn-outline-secondary">30d</button>
                                </div> */}
                            </div>
                            <ResponsiveContainer width="100%" height={200}>
                                <LineChart data={analytics?.daysData}>
                                    <XAxis dataKey="date" />
                                    <YAxis domain={[0, 100]} />
                                    <Tooltip />
                                    <Line
                                        type="monotone"
                                        dataKey="positive"
                                        stroke="#198754"
                                        strokeWidth={2}
                                        dot={false}
                                    />
                                    <Line
                                        type="monotone"
                                        dataKey="negative"
                                        stroke="#dc3545"
                                        strokeWidth={2}
                                        dot={false}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
